import React, { useState } from "react";
import TypewriterText from "./TypewriterText";
import "./CreditsBlock.css";

const THRESHOLD = 120;

export default function CreditsBlock({ credits }) {
  const [expanded, setExpanded] = useState(false);
  if (!credits) return null;

  const isLong = credits.length > THRESHOLD;

  return (
    <div className="credits-block">
      <div className="credits-text-wrap">
        <div className={`credits-text${isLong && !expanded ? " credits-text--collapsed" : ""}`}>
          <TypewriterText text={credits} charDelay={8} startDelay={0} />
        </div>
        {isLong && !expanded && <span className="credits-ellipsis">…</span>}
      </div>
      {isLong && (
        <button className="credits-toggle" onClick={() => setExpanded((e) => !e)}>
          {expanded ? "Collapse" : "See full credits"}
        </button>
      )}
    </div>
  );
}
